// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AwsEksNodeGroupTopology } from './AwsEksNodeGroupTopology';
import {
  AwsEksNodeGroupTopologyFromJSON,
  AwsEksNodeGroupTopologyFromJSONTyped,
  AwsEksNodeGroupTopologyToJSON,
  AwsEksNodeGroupTopologyToJSONTyped,
} from './AwsEksNodeGroupTopology';
import type { AwsEksNodeGroupTaint } from './AwsEksNodeGroupTaint';
import {
  AwsEksNodeGroupTaintFromJSON,
  AwsEksNodeGroupTaintFromJSONTyped,
  AwsEksNodeGroupTaintToJSON,
  AwsEksNodeGroupTaintToJSONTyped,
} from './AwsEksNodeGroupTaint';

/**
 *
 * @export
 * @interface AwsEksNodeGroup
 */
export interface AwsEksNodeGroup {
  /**
   *
   * @type {number}
   * @memberof AwsEksNodeGroup
   */
  desiredSize?: number;
  /**
   *
   * @type {number}
   * @memberof AwsEksNodeGroup
   */
  diskSizeGb?: number;
  /**
   *
   * @type {boolean}
   * @memberof AwsEksNodeGroup
   */
  enableMetrics?: boolean;
  /**
   *
   * @type {string}
   * @memberof AwsEksNodeGroup
   */
  instanceType?: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof AwsEksNodeGroup
   */
  labels?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof AwsEksNodeGroup
   */
  masterVersion?: string;
  /**
   *
   * @type {number}
   * @memberof AwsEksNodeGroup
   */
  maxSize?: number;
  /**
   *
   * @type {number}
   * @memberof AwsEksNodeGroup
   */
  minSize?: number;
  /**
   *
   * @type {string}
   * @memberof AwsEksNodeGroup
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof AwsEksNodeGroup
   */
  nodeVersion?: string;
  /**
   *
   * @type {string}
   * @memberof AwsEksNodeGroup
   */
  planeType?: string;
  /**
   *
   * @type {Array<AwsEksNodeGroupTaint>}
   * @memberof AwsEksNodeGroup
   */
  taints?: Array<AwsEksNodeGroupTaint>;
  /**
   *
   * @type {AwsEksNodeGroupTopology}
   * @memberof AwsEksNodeGroup
   */
  topology?: AwsEksNodeGroupTopology;
  /**
   *
   * @type {Array<string>}
   * @memberof AwsEksNodeGroup
   */
  zones?: Array<string>;
}

/**
 * Check if a given object implements the AwsEksNodeGroup interface.
 */
export function instanceOfAwsEksNodeGroup(
  value: object,
): value is AwsEksNodeGroup {
  return true;
}

export function AwsEksNodeGroupFromJSON(json: any): AwsEksNodeGroup {
  return AwsEksNodeGroupFromJSONTyped(json, false);
}

export function AwsEksNodeGroupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AwsEksNodeGroup {
  if (json == null) {
    return json;
  }
  return {
    desiredSize:
      json['desired_size'] == null ? undefined : json['desired_size'],
    diskSizeGb: json['disk_size_gb'] == null ? undefined : json['disk_size_gb'],
    enableMetrics:
      json['enable_metrics'] == null ? undefined : json['enable_metrics'],
    instanceType:
      json['instance_type'] == null ? undefined : json['instance_type'],
    labels: json['labels'] == null ? undefined : json['labels'],
    masterVersion:
      json['master_version'] == null ? undefined : json['master_version'],
    maxSize: json['max_size'] == null ? undefined : json['max_size'],
    minSize: json['min_size'] == null ? undefined : json['min_size'],
    name: json['name'] == null ? undefined : json['name'],
    nodeVersion:
      json['node_version'] == null ? undefined : json['node_version'],
    planeType: json['plane_type'] == null ? undefined : json['plane_type'],
    taints:
      json['taints'] == null
        ? undefined
        : (json['taints'] as Array<any>).map(AwsEksNodeGroupTaintFromJSON),
    topology:
      json['topology'] == null
        ? undefined
        : AwsEksNodeGroupTopologyFromJSON(json['topology']),
    zones: json['zones'] == null ? undefined : json['zones'],
  };
}

export function AwsEksNodeGroupToJSON(json: any): AwsEksNodeGroup {
  return AwsEksNodeGroupToJSONTyped(json, false);
}

export function AwsEksNodeGroupToJSONTyped(
  value?: AwsEksNodeGroup | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    desired_size: value['desiredSize'],
    disk_size_gb: value['diskSizeGb'],
    enable_metrics: value['enableMetrics'],
    instance_type: value['instanceType'],
    labels: value['labels'],
    master_version: value['masterVersion'],
    max_size: value['maxSize'],
    min_size: value['minSize'],
    name: value['name'],
    node_version: value['nodeVersion'],
    plane_type: value['planeType'],
    taints:
      value['taints'] == null
        ? undefined
        : (value['taints'] as Array<any>).map(AwsEksNodeGroupTaintToJSON),
    topology: AwsEksNodeGroupTopologyToJSON(value['topology']),
    zones: value['zones'],
  };
}
